import { type SerializableRecord } from '@post-office/message-template-contracts/serializable-record';
import { Stages } from '..';
import type {
	AnyBackendPlacementStage,
	AnyBackendPlacementStageData,
	BackendPlacementStageInput,
} from '../../../../create-placement/types';

export const applyHydrate = (
	hydrate: AnyBackendPlacementStage | undefined,
): ((
	params: BackendPlacementStageInput<SerializableRecord>,
) => Promise<AnyBackendPlacementStageData>) => Stages.maybe(hydrate);
